import React from "react";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { func, object, shape, string } from "prop-types";

import {
  ConfirmationWrapper,
  ContactConfirmationLinkWrapper,
  ModalHeading,
  ModalIconWrapper,
  ModalText,
  ModalTitle
} from "../../../../styled";

const PasswordRequiredToRegisterConfirmation = props => (
  <ConfirmationWrapper>
    <ModalIconWrapper>
      <FontAwesomeIcon color="primary" fontSize="33px" iconClass="checkmark" />
    </ModalIconWrapper>
    <ModalHeading scenario={props.scenario}>
      <ModalTitle scenario={props.scenario} type="primarySm">
        You shared this {props.data.sharedType}
      </ModalTitle>
    </ModalHeading>
    <ModalText>{props.data.confirmationText}</ModalText>
    <ContactConfirmationLinkWrapper>
      <TextLink
        href="#"
        onClick={e => {
          props.setScenario("PasswordRequiredToRegister", {
            email: props.data.email,
            origin: props.data.origin
          });
          e.preventDefault();
        }}
        theme="primaryTouchedBoldUnderline"
      >
        set a password to access your account
      </TextLink>
    </ContactConfirmationLinkWrapper>
  </ConfirmationWrapper>
);

PasswordRequiredToRegisterConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired,
    email: string.isRequired,
    origin: string.isRequired,
    sharedType: string.isRequired
  }).isRequired,
  scenario: string.isRequired,
  setScenario: func.isRequired
};

export default PasswordRequiredToRegisterConfirmation;
